var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4225 30H10.5C9.70435 30 8.94129 29.6839 8.37868 29.1213C7.81607 28.5587 7.5 27.7956 7.5 27V9C7.5 8.20435 7.81607 7.44129 8.37868 6.87868C8.94129 6.31607 9.70435 6 10.5 6H22.5C23.2956 6 24.0587 6.31607 24.6213 6.87868C25.1839 7.44129 25.5 8.20435 25.5 9V21M21 28.5L24 31.5L30 25.5M13.5 12H19.5M13.5 18H16.5",
    stroke: "#F74439",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.3074cb759a629747597e80fb1bc032ac.svg";
export { ForwardRef as ReactComponent };